import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://devapi.finsights.biz/kitaabhaidocappapi', // Replace with your backend URL
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;